var _updatingOptions = false;

(function () {
  'use strict';

  console.log('[FV] Variant logic v21 loaded');

  // ─── Sélecteurs ──────────────────────────────────────────────────
  function getProductSelect() { return document.querySelector('select[name*="-Product"]'); }
  function getSizeSelect()    { return document.querySelector('select[name*="-Size"]'); }
  function getStyleSelect()   { return document.querySelector('select[name*="-Style"]'); }
  function getVariantSelect() { return document.querySelector('select[name="variant-id"]'); }

  function getCurrentSupport() {
    var sel = getProductSelect();
    if (!sel) return '';
    var opt = sel.options[sel.selectedIndex];
    return opt ? opt.text.trim() : '';
  }

  // ─── Volet Style ─────────────────────────────────────────────────
  function hideStyleRow() {
    var sel = getStyleSelect();
    if (!sel) return;
    var row = sel.closest('p.no-js-hidden') || sel.parentElement.closest('p') || sel.parentElement;
    if (row) row.style.setProperty('display', 'none', 'important');
  }

  function showStyleRow() {
    var sel = getStyleSelect();
    if (!sel) return;
    var row = sel.closest('p.no-js-hidden') || sel.parentElement.closest('p') || sel.parentElement;
    if (row) row.style.removeProperty('display');
  }

  // ─── Forcer une valeur dans un select ────────────────────────────
  function selectByText(sel, text) {
    if (!sel) return false;
    var opt = Array.from(sel.options).find(function(o) {
      return o.text.trim().toLowerCase() === text.toLowerCase();
    });
    if (opt) {
      sel.value = opt.value;
      _updatingOptions = true;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      _updatingOptions = false;
      return true;
    }
    return false;
  }

  function selectByPartialText(sel, text) {
    if (!sel) return false;
    var opt = Array.from(sel.options).find(function(o) {
      return o.text.trim().toLowerCase().includes(text.toLowerCase());
    });
    if (opt) {
      sel.value = opt.value;
      _updatingOptions = true;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      _updatingOptions = false;
      return true;
    }
    return false;
  }

  // ─── Règles de correction ─────────────────────────────────────────
  function applyCorrections(s) {
    var sizeSelect  = getSizeSelect();
    var styleSelect = getStyleSelect();
    var currentSize  = sizeSelect  ? sizeSelect.options[sizeSelect.selectedIndex].text.trim() : '';
    var currentStyle = styleSelect ? styleSelect.options[styleSelect.selectedIndex].text.trim() : '';

    console.log('[FV] applyCorrections:', s, '/ size:', currentSize, '/ style:', currentStyle);

    if (s === 'affiche' || s === 'acrylique' || s === 'aluminium') {
      hideStyleRow();
      if (currentStyle !== '-') selectByText(styleSelect, '-');

} else if (s === 'affiche encadrée') {
  showStyleRow();
  // Forcer 30x45 SEULEMENT si 40x60 ou 16x24 (pas 60x90)
  if (currentSize.includes('40x60') || currentSize.includes('16x24')) {
    selectByPartialText(sizeSelect, '30x45');
  }
  if (!currentStyle || currentStyle === '-') {
    selectByText(styleSelect, 'Noir');
  }


} else if (s === 'affiche avec baguettes') {
  showStyleRow();
  if (!currentStyle || currentStyle === '-') {
    selectByText(styleSelect, 'Noir');
  }

} else if (s === 'impression sur mousse') {
  showStyleRow();
  // Mousse : Bois non disponible → forcer Noir
  if (!currentStyle || currentStyle === '-' || currentStyle.toLowerCase().includes('bois')) {
    selectByText(styleSelect, 'Noir');
  }
}
  }

  // ─── BV : masquage des boutons ────────────────────────────────────
  function getBVHiddenTexts(s) {
    if (s === 'affiche' || s === 'acrylique' || s === 'aluminium')
      return { taille: ['-'], couleur: ['Noir', 'Blanc', 'Bois naturel', 'Bois sombre'] };
    if (s === 'affiche encadrée')
      return { taille: ['-', '40x60', '16x24'], couleur: ['-'] };
    if (s === 'affiche avec baguettes')
      return { taille: ['-'], couleur: ['-'] };
    if (s === 'impression sur mousse')
      return { taille: ['-'], couleur: ['-', 'Bois naturel', 'Bois sombre'] };
    return { taille: ['-'], couleur: [] };
  }

  function watchBVChanges() {
    setInterval(function () {
      var s = getCurrentSupport().toLowerCase().trim();
      var hidden = getBVHiddenTexts(s);

      if (s === 'affiche' || s === 'acrylique' || s === 'aluminium') {
        hideStyleRow();
      } else {
        showStyleRow();
      }

      document.querySelectorAll('.bv_ul_inner').forEach(function (ul) {
        if (ul.getBoundingClientRect().height === 0) return;
        var isTaille = Array.from(ul.querySelectorAll('span.text')).some(function (t) {
          return t.textContent.includes('cm') || t.textContent.includes('x');
        });
        var hiddenTexts = isTaille ? hidden.taille : hidden.couleur;
        ul.querySelectorAll('span.li span.text').forEach(function (t) {
          var text = t.textContent.trim();
          if (!text) return;
          var hide = hiddenTexts.some(function (h) { return text.includes(h); });
          t.parentElement.style.setProperty('display', hide ? 'none' : '', 'important');
        });
      });
    }, 100);
  }

  // ─── Watch continu des valeurs select ────────────────────────────
 function watchStyleValue() {
  setInterval(function() {
    if (_updatingOptions) return;
    var s = getCurrentSupport().toLowerCase().trim();
    var styleSelect = getStyleSelect();
    var sizeSelect  = getSizeSelect();
    if (!styleSelect || !s) return;
    var currentStyle = styleSelect.options[styleSelect.selectedIndex] ? styleSelect.options[styleSelect.selectedIndex].text.trim() : '';
    var currentSize  = sizeSelect && sizeSelect.options[sizeSelect.selectedIndex] ? sizeSelect.options[sizeSelect.selectedIndex].text.trim() : '';

    // Affiche / Acrylique / Aluminium → masquer volet, forcer "-"
    if (s === 'affiche' || s === 'acrylique' || s === 'aluminium') {
      hideStyleRow();
      if (currentStyle !== '-') {
        selectByText(styleSelect, '-');
        syncVariantId();
      }

    // Encadrée / Baguettes → Noir seulement si "-" ou vide (pas Bois)
    } else if (s === 'affiche encadrée' || s === 'affiche avec baguettes') {
      showStyleRow();
      if (!currentStyle || currentStyle === '-') {
        selectByText(styleSelect, 'Noir');
        syncVariantId();
      }

    // Mousse → Noir si "-", vide ou Bois
    } else if (s === 'impression sur mousse') {
      showStyleRow();
      if (!currentStyle || currentStyle === '-' || currentStyle.toLowerCase().includes('bois')) {
        selectByText(styleSelect, 'Noir');
        syncVariantId();
      }
    }

    // Encadrée → forcer 30x45 si 40x60
    if (s === 'affiche encadrée' && (currentSize.includes('40x60') || currentSize.includes('16x24'))) {
      selectByPartialText(sizeSelect, '30x45');
      syncVariantId();
    }
  }, 150);
}


  // ─── Sync variant ────────────────────────────────────────────────
  function watchSelectOptions() {
  setInterval(function() {
    var s = getCurrentSupport().toLowerCase().trim();
    var styleSelect = getStyleSelect();
    var sizeSelect  = getSizeSelect();
    if (!styleSelect || !sizeSelect) return;

    Array.from(styleSelect.options).forEach(function(o) {
      var text = o.text.trim();
      if (s === 'affiche' || s === 'acrylique' || s === 'aluminium') {
        // Masquer tout sauf "-"
        o.disabled = (text !== '-');
        o.hidden   = (text !== '-');
      } else if (s === 'affiche encadrée' || s === 'affiche avec baguettes') {
        // Masquer "-"
        o.disabled = (text === '-');
        o.hidden   = (text === '-');
      } else if (s === 'impression sur mousse') {
        // Masquer "-", Bois naturel, Bois sombre
        var hide = (text === '-' || text.toLowerCase().includes('bois'));
        o.disabled = hide;
        o.hidden   = hide;
      }
    });

    Array.from(sizeSelect.options).forEach(function(o) {
      var text = o.text.trim();
      if (s === 'affiche encadrée') {
        var hide = (text === '-' || text.includes('40x60') || text.includes('16x24'));
        o.disabled = hide;
        o.hidden   = hide;
      } else {
        // Masquer uniquement "-" pour les autres
        o.disabled = (text === '-');
        o.hidden   = (text === '-');
      }
    });
  }, 150);
}

function syncVariantId() {
    var variantSelect = getVariantSelect();
    if (!variantSelect) return;
    var selectedProduct = getCurrentSupport();
    var sizeSelect  = getSizeSelect();
    var styleSelect = getStyleSelect();
    var selectedSize  = sizeSelect  ? sizeSelect.options[sizeSelect.selectedIndex].text.trim() : '';
    var selectedStyle = styleSelect ? styleSelect.options[styleSelect.selectedIndex].text.trim() : '';

    console.log('[FV] Sync:', selectedProduct, '/', selectedSize, '/', selectedStyle);

    var matchingOption = Array.from(variantSelect.options).find(function (o) {
      var text = o.text.trim();
      return text.includes(selectedProduct) &&
             text.includes(selectedSize) &&
             (selectedStyle === '-' || selectedStyle === '' || text.includes(selectedStyle));
    });

    if (matchingOption) {
      variantSelect.value = matchingOption.value;
      document.querySelectorAll('input[name="id"], input[name="variant-id"]').forEach(function (input) {
        input.value = matchingOption.value;
      });
      console.log('[FV] Variant OK:', matchingOption.text);
    } else {
      console.warn('[FV] Aucune variante:', selectedProduct, '/', selectedSize, '/', selectedStyle);
    }
  }

  // ─── Update principal ────────────────────────────────────────────
  function updateOptions() {
    if (_updatingOptions) return;
    _updatingOptions = true;
    var support = getCurrentSupport();
    if (!support) { _updatingOptions = false; return; }
    var s = support.toLowerCase().trim();
    console.log('[FV] updateOptions:', s);
    applyCorrections(s);
    syncVariantId();
    _updatingOptions = false;
  }

  // ─── Default variant ─────────────────────────────────────────────
  function setDefaultVariant() {
    var productSelect = getProductSelect();
    if (!productSelect) { console.warn('[FV] pas de productSelect'); return; }
    console.log('[FV] Options Product:', Array.from(productSelect.options).map(function(o) { return o.text.trim(); }));
    var afficheOption = Array.from(productSelect.options).find(function (o) {
      return o.text.trim().toLowerCase() === 'affiche' && !o.disabled;
    });
    console.log('[FV] Affiche trouvé:', afficheOption ? 'OUI' : 'NON');
    if (afficheOption && productSelect.value !== afficheOption.value) {
      productSelect.value = afficheOption.value;
      productSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateOptions();
  }

  // ─── Listeners ───────────────────────────────────────────────────
  function attachListeners() {
    document.addEventListener('change', function (e) {
      if (_updatingOptions) return;
      if (e.target && e.target.name && (
        e.target.name.includes('-Product') ||
        e.target.name.includes('-Size') ||
        e.target.name.includes('-Style')
      )) {
        setTimeout(updateOptions, 500);
      }
    });
  }

  function interceptAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      syncVariantId();
    }, true);
  }

  // ─── Init ────────────────────────────────────────────────────────
  function watchBVClicks() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('span.li');
    if (!btn) return;
    var ul = btn.closest('.bv_ul_inner');
    if (!ul) return;

    var text = btn.querySelector('span.text');
    if (!text) return;
    var val = text.textContent.trim();

    var isTaille = Array.from(ul.querySelectorAll('span.text')).some(function(t) {
      return t.textContent.includes('cm') || t.textContent.includes('x');
    });

    if (isTaille) {
      var sizeSelect = getSizeSelect();
      if (sizeSelect) {
        selectByText(sizeSelect, val);
        console.log('[FV] BV click taille:', val);
      }
    } else {
      var styleSelect = getStyleSelect();
      if (styleSelect) {
        selectByText(styleSelect, val);
        console.log('[FV] BV click couleur:', val);
      }
    }

    setTimeout(syncVariantId, 50);
  });
}

  function init() {
    if (!window.location.pathname.includes('/products/')) return;
    var productSelect = getProductSelect();
    if (productSelect) {
      attachListeners();
      interceptAddToCart();
      watchBVClicks();
      watchBVChanges();
watchStyleValue();
watchSelectOptions();

      var url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) {
        setDefaultVariant();
      } else {
        updateOptions();
      }
    } else {
      setTimeout(init, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }

})();
